/*
 * @Author: Ryan
 * @Date: 2026-01-16
 * @Description: E-Commerce Landing Hero Section - 居中布局 + 视频轮播 + Logo 滚动
 */
import React from 'react';

import StartButton from '@/3.0/ai-avatar-generator/seo/StartButton';

import VideoCarousel, { VideoItem } from '../../common/VideoCarousel';
import styles from './index.module.scss';

export interface ECommerceHeroSectionProps {
  /** 主标题 */
  title: string;
  /** 高亮标题（渐变色），可选 */
  highlightTitle?: string;
  /** 描述文本 */
  description: string;
  /** CTA 按钮文本 */
  ctaText: string;
  /** CTA 跳转链接 */
  ctaUrl?: string;
  /** 视频列表 */
  videos?: VideoItem[];
}

const ECommerceHeroSection: React.FC<ECommerceHeroSectionProps> = ({
  title,
  highlightTitle,
  description,
  ctaText,
  ctaUrl = '/ai-video-generator',
  videos,
}) => {
  return (
    <section className={styles.section}>
      {/* 标题区域 - 受最大宽度限制 */}
      <div className={styles.container}>
        <div className={styles.header}>
          <h1 className={styles.title}>
            {title}
            {highlightTitle && (
              <span className={styles.highlightTitle}>{highlightTitle}</span>
            )}
          </h1>
          <p className={styles.description}>{description}</p>
          <div className={styles.ctaWrapper}>
            <StartButton text={ctaText} href={ctaUrl} className={styles.ctaButton} />
          </div>
        </div>
      </div>

      {/* 视频滚动区域 - 全屏宽度（可选） */}
      {videos && videos.length > 0 && (
        <div className={styles.carouselWrapper}>
          <VideoCarousel videos={videos} autoPlay />
        </div>
      )}
    </section>
  );
};

export default ECommerceHeroSection;
